import {
  NJInlineMessage,
  NJSpinner,
} from "@engie-group/fluid-design-system-react";
import { SessionRow } from "./SessionRow";
import { useSessions } from "./useSessions";

/** Session list scoped to an agent (used on the agent detail page). Starting a session is done
 * from the single "Start session" button in the page header — not repeated here. */
export function SessionListPanel({ agentId }: { agentId?: string }) {
  const { data: sessions, isLoading, isError } = useSessions();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center py-12">
        <NJSpinner aria-label="Loading sessions" />
      </div>
    );
  }

  if (isError) {
    return (
      <NJInlineMessage variant="error">
        Could not load the sessions.
      </NJInlineMessage>
    );
  }

  const scopedSessions = agentId
    ? (sessions ?? []).filter((session) => session.agentId === agentId)
    : (sessions ?? []);

  return (
    <div className="flex flex-col gap-2">
      {scopedSessions.length === 0 ? (
        <p className="text-sm text-nj-neutral-secondary-default">
          No sessions yet.
        </p>
      ) : (
        <div className="flex flex-col divide-y divide-nj-neutral-subtle-default">
          {scopedSessions.map((session) => (
            <SessionRow key={session.id} session={session} />
          ))}
        </div>
      )}
    </div>
  );
}
